// @ts-check
// NOTE: This script is loaded on all pages EXCEPT the product list/search
// page. See the search-page.js file for changes that only effect the product
// list/search page.
import {
    GlobalSearchBarComponent,
    GlobalSearchBarComponentEventNames,
    ProductSearchService,
    ProductSearchServiceEventNames,
    SearchPageStateUrlManagerService
} from "../modules/search";
import { convertFacetArrayToSearchFacetClientDtoV2 } from "../modules/search/helpers";
import { debounce } from "../modules/utilities/debounce";

/** @type {Map<SearchViewType, SearchPageStateDefaults>} */
const defaultSearchPageStates = new Map();

defaultSearchPageStates.set("List", {
    resourceCategory: null,
    searchTerm: "",
    page: 1,
    pageSize: 48,
    sort: "productNameAsc",
    forceExpandFacet: "",
    filterUserFavorites: false,
});

defaultSearchPageStates.set("Tile", {
    resourceCategory: null,
    searchTerm: "",
    page: 1,
    pageSize: 48,
    sort: "productNameAsc",
    forceExpandFacet: "",
    filterUserFavorites: false,
});

defaultSearchPageStates.set("Global", {
    resourceCategory: null,
    searchTerm: "",
    page: 1,
    pageSize: 48,
    sort: "productNameAsc",
    forceExpandFacet: "",
    filterUserFavorites: false,
});

const productSearchService = new ProductSearchService();
const searchPageStateUrlManagerService = new SearchPageStateUrlManagerService(defaultSearchPageStates);

const globalSearchBarComponent = new GlobalSearchBarComponent(
    productSearchService,
    searchPageStateUrlManagerService,
    false
);

// This is for backwards compatibility reasons.
window.site = window.site || {};
//window.site.AddressDeleteConfirmationModal = addressDeleteConfirmationModal;
// window.site.DefaultShippingAddressModal = defaultShippingAddressModal;
window.site.GlobalSearchBar = globalSearchBarComponent;

$(function () {
    globalSearchBarComponent.initialize();

    globalSearchBarComponent.addEventListener(GlobalSearchBarComponentEventNames.RefreshResults, function () {
        // GTM Search Event
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ event: "search", search_term: globalSearchBarComponent.getSearchTerm() });
    });

    let _lastSentSuggestionsSearchRequestBody = "";

    const searchSuggestionsDebounceFn = debounce(function (abortSignal) {
        let activePage = 1;
        let activePageSize = 6;
        const searchTerm = globalSearchBarComponent.getSearchTerm();
        const facets = [{
            category: "",
            fieldName: "resourceCategories",
            value: "PRD|SALES",
            displayName: "",
            count: 0,
            selected: true,
            sortOrder: 1,
        }];

        // Need to append the resourceCategroy to the facets.
        const searchClientDtoFacets = convertFacetArrayToSearchFacetClientDtoV2(facets);

        // Just need to trigger the request. The event listeners in the
        // components should pick up the changes.
        /** @type {SearchRequestViewModelV2} */
        const data = {
            facets: searchClientDtoFacets,
            forceExpandFacet: null,
            orderBy: "productNameAsc",
            page: activePage,
            pageSize: activePageSize,
            renderPager: false,
            renderFacets: false,
            renderFeaturedProducts: false,
            renderPills: false,
            renderResults: false,
            renderSuggestions: true,
            resourceCategories: "PRD|SALES",
            searchTerm: searchTerm,
            searchViewType: "List",
        };

        let dataAsJson = JSON.stringify(data);

        if (dataAsJson === _lastSentSuggestionsSearchRequestBody) {
            productSearchService.dispatchEvent(new CustomEvent(ProductSearchServiceEventNames.refreshSuggestionsComplete));
            return;
        } else {
            _lastSentSuggestionsSearchRequestBody = dataAsJson;
        }

        productSearchService
            .searchV2Async(
                data,
                abortSignal
            )
            .catch(function (error) {
                if (abortSignal.aborted) {
                    return;
                }

                productSearchService.dispatchEvent(new CustomEvent(ProductSearchServiceEventNames.refreshSuggestionsComplete));
                console.error(error);
            });
    }, 200);

    // Listen for events that trigger the search suggestions to refresh.
    globalSearchBarComponent.addEventListener("refresh-suggestions-start", function (evt) {
        searchSuggestionsDebounceFn();
    });

    globalSearchBarComponent.addEventListener("refresh-suggestions-start", function (evt) {
        searchSuggestionsDebounceFn();
    });
});
